// extracted by mini-css-extract-plugin
module.exports =  {"container":"e3afc254ff--container--sH5oB","content":"e3afc254ff--content--Vg2_8","header":"e3afc254ff--header--E5NfC","text":"e3afc254ff--text--XPvkq"};